<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="list-grade mb-5">
              <div>
                <label class="ml-3 mb-3">
                  How long have you been teaching in {{ school.schoolName}} ?
                </label>
                <br />
                <br />
                <div class="ml-3">
                <label>Start Date</label>
                <br />
                <input type="text" />
                <br /><br />
                 <label>End Date</label>
                <br />
                <input type="text" />
                </div>
                
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="bottom-center text-center">
      <CButton
        style="
          position: fixed;
          bottom: 30px;
          left: 0px;
          right: 0px;
          text-align: center;
          margin: 0 auto;"
        color="primary"
        class="btn-select-blue mt-5"
        @click="GoToExperience(school.id)"
      >
        Next</CButton
      >
    </div>
    <div class="header-top">Teaching Experience</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
export default {
  data() {
    return {
      user: {},
      teacher: {},
      school: {},
      // edus: [
      //   {
      //       id:1,
      //       eduName:"SMK Sultan Abu Bakar (ECJB)",
      //   },
      //    {
      //       id:2,
      //       eduName:"SMK Sultan Ismail",
      //   },
      //    {
      //       id:3,
      //       eduName:"MRSM Jasin",
      //   },
      //    {
      //       id:4,
      //       eduName:"SMS Tuanku Munawir",
      //   },

      // ],
      FilterEducation: [
        {
            id:1,
            eduName:"SMK Sultan Abu Bakar (ECJB)",
        },
         {
            id:2,
            eduName:"SMK Sultan Ismail",
        },
         {
            id:3,
            eduName:"MRSM Jasin",
        },
         {
            id:4,
            eduName:"SMS Tuanku Munawir",
        },
      ],
      SearchQuery: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetTeacherProfile(this.user.id);
            this.GetSchoolById(this.$route.query.id);
          }
        });
    },
    GetTeacherProfile() {
      this.$API
        .get(this.$TeacherProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacher = response.data;
            this.photoURL = this.teacher;
              console.log("teacher", this.teacher);
          }
        });
    },

    GetSchoolById() {
      this.$API
        .get(this.$SelectSchoolById + "?id=" + this.$route.query.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.school = response.data;
            this.schoolid = this.school.id;
            console.log("school", this.schoolid);
          }
        });
    },

    GoBack() {
      this.$router.back();
    },
    
    // GetSubject() {
    //   this.$API
    //     .get(this.$SubjectListAuthorize, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.subject = response.data;
    //         this.FilterSubject = this.subject;
    //       }
    //     });
    // },
     ApplyFilter: function () {
      var arr = _.orderBy(this.edus, ["eduName"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ eduName }) =>
          _.some([
            _.includes(!eduName || eduName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilterEducation = result;
      }
    },

     GoToExperience(id){

       this.$router.push(
        "BTTeachingExperience?id=" +
        id);
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
input[type="text"] {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="checkbox"] {
opacity: 0;
font-family: 'Montserrat';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 20px;
/* identical to box height */


/* #000A2C */

color: #000A2C;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>